export class XmlParser {

  /**
   * @param {null} xml XML app-chart table data
   */
  constructor (xml) {
    this.xml = xml
    this.xml = new DOMParser().parseFromString(xml, 'application/xml')
  }

  /**
     * @param {string} xpath XPath to XML table data
     * @returns {string | null | Element[]} Node data
     */
  getData (xpath) {
    if (!this.xml) {
      return []
    }
    let iterator = this.xml.evaluate(xpath, this.xml, null, XPathResult.ANY_TYPE, null)

    /** @type {Element[]} */
    let textArray = []
    try {
      let thisNode = iterator.iterateNext()
      while (thisNode) {
        textArray.push(thisNode)
        thisNode = iterator.iterateNext()
      }
    } catch (e) {
      // alert('Error: Document tree modified during iteration ' + e)
    }
    if (textArray.length > 0 && textArray[0].children.length > 0) {
      return textArray
    } else {
      return textArray[0] ? textArray[0].textContent : ''
    }
  }
}
